<template>
  <div class="d-flex align-items-center flex-wrap">
    <b-button-group size="sm" class="mr-1 mb-50 mb-md-0">
      <b-button
        v-for="preset in presets"
        :key="preset.label"
        :variant="preset.label === value.label ? 'primary' : 'outline-primary'"
        :disabled="disabled"
        @click="$emit('input', preset)"
      >
        {{ preset.shortLabel }}
      </b-button>
    </b-button-group>

    <b-button
      size="sm"
      variant="outline-secondary"
      :disabled="disabled"
      @click="$emit('refresh')"
    >
      <feather-icon icon="RefreshCwIcon" :class="{ 'spin-icon': disabled }" />
    </b-button>
  </div>
</template>

<script>
import { BButton, BButtonGroup } from 'bootstrap-vue'
import { WINDOW_PRESETS } from './usageFormat'

export default {
  name: 'UsageWindowPicker',
  components: {
    BButton,
    BButtonGroup,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    presets() {
      return WINDOW_PRESETS.map(preset => ({
        ...preset,
        shortLabel: preset.label.replace('Last ', ''),
      }))
    },
  },
}
</script>

<style scoped>
.spin-icon {
  animation: usage-spin 1s linear infinite;
}

@keyframes usage-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
